import { AddressResponse } from "./AddressResponse";

export class Address {
  name: string;
  surname: string;
  addressResponse: AddressResponse
}
